import {makeServerRequest} from "./server-request";
import {makeQuizServerRequest} from "../quiz-admin-api-services/quiz-server-request";
import {REQUEST_METHOD} from "../../../shared/utils/helper";
import {QUIZ_BASE_URL} from "../../../shared/utils/quiz-api-services";
let userId = '';
let userRole = '';
export let serviceType = 'Form'; //or set as 'Quiz'
export const setUserId = id => userId = id;
export const setRole = role => userRole = role;
export const setServiceType = type => serviceType = type;

export const getAllAdminHistories = (pageIndex, limit, sortBy, successFunction, failureFunction) => {
    const data = JSON.stringify({
        'user_id': userId,
        'page_index': pageIndex,
        'limit': limit,
        "sort_by": sortBy
    })
    makeServerRequest('/getadminhistories', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const getAdminHistoriesByDate = (from, to, pageIndex, limit, successFunction, failureFunction) => {
    const data = JSON.stringify({
        from: from,
        to: to,
        user_id: userId,
        page_index: pageIndex,
        limit: limit
    })
    makeServerRequest('/getadminhistoriesbydate', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const getQuizAdminHistoriesByDate = (from, to, pageIndex, limit, successFunction, failureFunction) => {
    const data = JSON.stringify({
        from: from,
        to: to,
        user_id: userId,
        page_index: pageIndex,
        limit: limit
    })
    makeQuizServerRequest(QUIZ_BASE_URL + '/getquizadminhistoriesbydate', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}

export const HISTORY_ACTION = {
    ADD: 'Add',
    UPDATE: 'Update',
    REMOVE: 'Remove',
    VERIFIED: 'Verified',
    HELP_REQUESTED: 'Help Requested',
    PREMIUM_ACCESS: "Premium Access"
}
export const addToHistory = (action, description) => {
    const data = JSON.stringify({
        "user_id": userId,
        "role": userRole,
        "service_type": serviceType,
        "action": action,
        "description": description
    })
    const historySuccess = () => null
    const historyFailed = err => console.log(err)
    makeServerRequest('/createadminhistory', REQUEST_METHOD.POST, data, historySuccess, historyFailed)
}
export const addToQuizHistory = (action, description) => {
    const data = JSON.stringify({
        "user_id": userId,
        "role": userRole,
        "service_type": serviceType,
        "action": action,
        "description": description
    })
    const historySuccess = () => null
    const historyFailed = err => console.log(err)
    makeQuizServerRequest(QUIZ_BASE_URL + '/createadminhistory', REQUEST_METHOD.POST, data, historySuccess, historyFailed)
}
export const getAllAdminQuizHistories = (pageIndex, limit, sortBy, successFunction, failureFunction) => {
    const data = JSON.stringify({
        'user_id': userId,
        'page_index': pageIndex,
        'limit': limit,
        "sort_by": sortBy
    })
    makeQuizServerRequest(QUIZ_BASE_URL + '/getadminhistories', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}
export const adminHistorySearchForForm = (searchValue, pageIndex, limit, successFunction, failureFunction) => {
    const data = JSON.stringify({
        "search_text": searchValue,
        "page_index": pageIndex,
        "limit": limit
    })
    makeServerRequest('/adminhistorysearch', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}
export const adminHistorySearchForQuiz = (searchValue, pageIndex, limit, successFunction, failureFunction) => {
    const data = JSON.stringify({
        "search_text": searchValue,
        "page_index": pageIndex,
        "limit": limit
    })
    makeQuizServerRequest(QUIZ_BASE_URL + '/adminhistorysearch', REQUEST_METHOD.POST, data, successFunction, failureFunction)
}